<template lang="pug">
div
  slide-show
  about
  products
  parts
  brands
</template>

<script>
import SlideShow from "./SlideShow";
import About from "./About";
import Products from "./Products";
import Parts from "./Parts";
import Brands from "./Brands";

export default {
  components: {
    SlideShow,
    About,
    Products,
    Parts,
    Brands,
  },
};
</script>
